import { render } from "./LinksTableComponent.vue?vue&type=template&id=13058d4a"
import script from "./LinksTableComponent.vue?vue&type=script&lang=js"
export * from "./LinksTableComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__